import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {FlexLayoutModule} from '@angular/flex-layout';
import { MatTabsModule, MatSidenavModule, MatToolbarModule, MatIconModule, MatButtonModule, MatListModule } from '@angular/material';
import { MainComponent } from './components/main/main.component';
import { HeaderComponent } from './components/header/header.component';
import { SidenavListComponent } from './components/sidenav-list/sidenav-list.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { TextMenuComponent } from './components/text-menu/text-menu.component';
import { ImageLeftMenuComponent } from './components/image-left-menu/image-left-menu.component';
import { ImageRightMenuComponent } from './components/image-right-menu/image-right-menu.component';
import { ContactComponent } from './components/contact/contact.component';
import { AgmCoreModule } from '@agm/core';
import { SellerComponent } from './components/seller/seller.component';
import { SellerRightComponent } from './components/seller-right/seller-right.component';
import { InViewportModule } from 'ng-in-viewport';
import { SellerMainComponent } from './components/seller-main/seller-main.component';
import { DoubleImageBottomComponent } from './components/double-image-bottom/double-image-bottom.component';
import { HttpClientModule } from '@angular/common/http';
import { FooterComponent } from './components/footer/footer.component';
import { ImpressumComponent } from './components/impressum/impressum.component';
import { NgxCsvParserModule } from 'ngx-csv-parser';
import { InfoComponent } from './modals/info/info.component';

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    HeaderComponent,
    SidenavListComponent,
    TextMenuComponent,
    ImageLeftMenuComponent,
    ImageRightMenuComponent,
    ContactComponent,
    SellerComponent,
    SellerRightComponent,
    SellerMainComponent,
    DoubleImageBottomComponent,
    FooterComponent,
    ImpressumComponent,
    InfoComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    NgbModule,
    InViewportModule,
    HttpClientModule,
    NgxCsvParserModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyDVTAqZNzOYhJGGskL-n0BcK4b5pKNfBQY",
      libraries: ["places", "geometry"]
      /* apiKey is required, unless you are a premium customer, in which case you can use clientId */
  })
  ],
  exports:[
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatListModule,
    InfoComponent
  ],
  entryComponents: [InfoComponent],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
